import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Shield, LogOut } from "lucide-react";

export default function Header() {
  const { user, logout } = useAuth();
  const loc = useLocation();
  if (loc.pathname === "/login" || loc.pathname === "/register") return null;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3">
          <img src="/logo.jpg" alt="Blue Line Security Consulting" className="h-10 w-auto" />
          <div className="leading-tight">
            <div className="text-sm font-bold tracking-tight text-slate-900" style={{ fontFamily: "Chivo, sans-serif" }}>
              CA CCW Training
            </div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-slate-500">
              by Blue Line Security Consulting
            </div>
          </div>
        </Link>
        <nav className="flex items-center gap-4">
          {user && user !== false && (
            <>
              <Link to="/dashboard" data-testid="nav-dashboard" className="text-sm font-medium text-slate-700 hover:text-slate-900">
                Dashboard
              </Link>
              {user.role === "admin" && (
                <>
                  <Link to="/admin" data-testid="nav-admin" className="text-sm font-medium text-slate-700 hover:text-slate-900">
                    Admin
                  </Link>
                  <Link to="/admin/range" data-testid="nav-admin-range" className="text-sm font-medium text-slate-700 hover:text-slate-900">
                    Range
                  </Link>
                  <Link to="/admin/embed" data-testid="nav-admin-embed" className="text-sm font-medium text-slate-700 hover:text-slate-900">
                    Embed
                  </Link>
                </>
              )}
              <span className="hidden sm:inline text-xs text-slate-500">{user.email}</span>
              <button
                data-testid="logout-btn"
                onClick={logout}
                className="inline-flex items-center gap-2 text-sm text-slate-700 hover:text-slate-900"
              >
                <LogOut className="h-4 w-4" /> Sign out
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
